module.exports = __webpack_public_path__ + "static/1-1200-d89cb25c76da90957e6719334e2e3fb0.png";